import { useState, useCallback } from 'react';

export function useImagePreview(initialUrl: string | null = null) {
  const [previewUrl, setPreviewUrl] = useState<string | null>(initialUrl);

  const handlePreviewFileChange = useCallback(
    (file: File | null, fallbackUrl: string | null = null) => {
      if (file) {
        setPreviewUrl(URL.createObjectURL(file));
      } else {
        setPreviewUrl(fallbackUrl ?? null);
      }
    },
    []
  );

  return {
    previewUrl,
    setPreviewUrl,
    handlePreviewFileChange,
  };
}
